<template>
  <section id="hero" class="relative flex flex-col justify-center min-h-screen bg-gradient-to-br from-indigo-50 via-white to-indigo-100 dark:from-dark-bg dark:via-dark-surface dark:to-dark-bg overflow-hidden transition-colors duration-300">
    <div class="section-container relative z-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 w-full">
      <!-- Text Block -->
      <div class="flex flex-col items-center lg:items-start text-center lg:text-left w-full lg:w-7/12" ref="heroContent" data-animate>
        <h1 class="text-4xl md:text-6xl font-bold font-heading text-text-main dark:text-white mb-6 leading-tight transition-colors duration-300">
          {{ t('hero.title') }}
        </h1>
        <p class="text-lg md:text-xl text-text-secondary dark:text-slate-300 max-w-3xl mb-10 leading-relaxed transition-colors duration-300">
          {{ t('hero.subtitle') }}
        </p>
        <a href="#services" class="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 rounded-xl font-semibold text-lg bg-accent hover:bg-accent-dark text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-card-hover">
          {{ t('hero.cta') }}
        </a>
      </div>

      <!-- Image Block -->
      <div class="w-full lg:w-5/12 relative mt-8 lg:mt-0" ref="heroImage" data-animate>
        <!-- Decorative elements behind image -->
        <div class="absolute -top-10 -right-10 w-64 h-64 bg-primary/20 dark:bg-primary/10 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-70 z-0 pointer-events-none"></div>
        <div class="absolute -bottom-10 -left-10 w-64 h-64 bg-indigo-300/30 dark:bg-indigo-900/20 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-70 z-0 pointer-events-none"></div>

        <img :src="require('@/assets/img/stock/hero-datacenter.jpg')" :alt="t('images.hero.alt')" class="relative z-10 rounded-2xl shadow-2xl object-cover w-full" />
      </div>
    </div>

    <!-- Scroll Down Indicator -->
    <div class="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center z-10">
      <a href="#services" class="text-text-secondary hover:text-primary dark:text-slate-400 dark:hover:text-white transition-colors duration-300" aria-label="Scroll down">
        <ChevronDown class="w-10 h-10 animate-bounce" />
      </a>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ChevronDown } from 'lucide-vue-next'
import { useAnimateOnScroll } from '@/composables/useAnimateOnScroll'

const { t } = useI18n({ useScope: 'global' })
const heroContent = ref(null)
const heroImage = ref(null)

useAnimateOnScroll(heroContent)
useAnimateOnScroll(heroImage, { animateClass: 'animate-in-right' })
</script>
